export default __webpack_public_path__ + "static/media/pride_exp_table.9c6e13ee.png";